import axios from "axios";
import { appConfig } from "@/types/appConfig.type.ts";

import type { AxiosInstance } from "axios";

const API_URL: string = `${appConfig.VITE_API_BASE_URL.replace(/\/$/, "")}/api`;

const instance: AxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": localStorage.getItem("language") || "fr",
  },
});

export default instance;
